__turbopack_context__.v({
  "className": "jmJ3ga_className",
  "variable": "jmJ3ga_variable",
});
